/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GA4_EVENT_REGISTER_BEGIN, PAGE_DATA_LAYER, REGISTER_BEGIN } from '@/data/constants/gtm';
import { getGTMRegisterBeginEventData } from '@/data/events/data/gtm/RegisterBegin';
import { getGTMConfig } from '@/data/events/handlers/gtm';
import { GTMRegisterBeginPayload } from '@/data/types/GTM';
import { error as logError } from '@/data/utils/loggerUtil';
import TagManager from 'react-gtm-module';

export const measure_GA4 = async (
	data: ReturnType<typeof getGTMRegisterBeginEventData>
) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: GA4_EVENT_REGISTER_BEGIN, ...data },
		dataLayerName,
	});
};

export const measure_UA = async (
	data: ReturnType<typeof getGTMRegisterBeginEventData>
) => {
	const dataLayerName = PAGE_DATA_LAYER;
	TagManager.dataLayer({
		dataLayer: { event: REGISTER_BEGIN, ...data },
		dataLayerName,
	});
};

export const sendGTMRegisterBeginEvent = async (payload: GTMRegisterBeginPayload) => {
	const { ga4, ua } = getGTMConfig(payload.settings);

	if (ua || ga4) {
		const data = getGTMRegisterBeginEventData(payload);
		if (ua) {
			try {
				await measure_UA(data);
			} catch (error) {
				logError(
					undefined,
					'RegisterBegin: sendGTMRegisterBeginEvent: measure_UA: error: %o',
					error
				);
			}
		}

		if (ga4) {
			try {
				await measure_GA4(data);
			} catch (error) {
				logError(
					undefined,
					'RegisterBegin: sendGTMRegisterBeginEvent: measure_GA4: error: %o',
					error
				);
			}
		}
	}
};
